// extracted by mini-css-extract-plugin
export var details = "_eh-0";
export var inspectorPopover = "_eh-1";